
import {
  isProductConfigurable
} from "@/util/isProductConfigurable"
import {
  useCallback,
  useMemo
} from "react"
import type {
  ProductRoot
} from "../types/product"


export const useGetInstockFabricOptions = ({
  product,
  oldValues
}: {
  product: ProductRoot,
  oldValues: any[]
}) => {
  const variants = useMemo(() => product?.variants || [], [product?.variants])

  const findVariants = useCallback(
    (item_value_index: number) => {
      const match =
                variants &&
                variants.filter((variant) => {
                  const {
                    attributes 
                  } = variant || {}

                  const findAttribute = attributes.find((item: any) => item.code === "aw_fabric_option")

                  const {
                    value_index: variant_value_index 
                  } = findAttribute || {}

                  return variant_value_index === item_value_index
                })

      return match
    },
    [variants]
  )

  // 将 outofstock 的放在后面
  const values = useMemo(() => {

    if (!isProductConfigurable(product)) {
      return oldValues
    }
    
    const instockArray: any[] = []
    const outofStockArray: any[] = []
    
    oldValues?.forEach((item: any) => {
      const {
        value_index: item_value_index 
      } = item || {}
    
      const match = findVariants(item_value_index)
  
      const allOutOfStock = match?.every((item: any) => item.product.stock_status === "OUT_OF_STOCK")
    
      if (allOutOfStock) {
        outofStockArray.push(item)
      } else {
        instockArray.push(item)
      }
    })
    
    return [...instockArray]
    // return [...instockArray, ...outofStockArray]
  }, [findVariants, oldValues, product])

  return {
    values
  }
}
